import { FundingWatcher } from './FundingWatcher';
import { LiquidationAlertsWatcher } from './LiquidationAlertsWatcher';
import { WindowTitleUpdater } from './WindowTitleUpdater';
import { useAppConfigWatcher } from '../store/watchers/useAppConfigWatcher';
import { useAppAccountWatcher } from '../store/watchers/useAppAccountWatcher';
import { useTraderProfileWatcher } from '../store/watchers/useTraderProfileWatcher';
import { useTradingWebSocket } from '../hooks/ws/useTradingWebSocket';
import { useMarketWebSocket } from '../hooks/ws/useMarketDataWebSocket';
import { useOrderBookMarketSync } from '../features/order_book/hooks/useOrderBookMarketSync.ts';
import { BackgroundReconnectionWatcher } from './BackgroundReconnectionWatcher';

export const GlobalWatchers = () => {
  useAppConfigWatcher();
  useAppAccountWatcher();
  useTraderProfileWatcher();
  useTradingWebSocket();
  useMarketWebSocket();
  useOrderBookMarketSync();

  return (
    <>
      <FundingWatcher />
      <LiquidationAlertsWatcher />
      <WindowTitleUpdater />
      <BackgroundReconnectionWatcher />
    </>
  );
};
